(function (window, document) {
    'use strict';

    var sprite = '/assets/icons/bmh-icons.svg';
    var selector = 'i.fas, i.far, i.fab, i.fa';

    function replaceIcon(icon) {
        if (!icon || icon.getAttribute('data-bmh-svg-icon') === 'true') {
            return;
        }

        var classes = Array.prototype.slice.call(icon.classList);
        var iconClass = classes.find(function (name) {
            return name.indexOf('fa-') === 0 && name !== 'fa-fw';
        });

        if (!iconClass) {
            return;
        }

        var prefix = icon.classList.contains('fab')
            ? 'fab'
            : icon.classList.contains('far')
                ? 'far'
                : 'fas';
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');

        icon.setAttribute('data-bmh-svg-icon', 'true');
        icon.textContent = '';
        svg.setAttribute('class', 'bmh-svg-icon');
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('aria-hidden', 'true');
        use.setAttribute('href', sprite + '#' + prefix + '-' + iconClass.slice(3));
        svg.appendChild(use);
        icon.appendChild(svg);
    }

    function replaceIcons(root) {
        if (root.matches && root.matches(selector)) {
            replaceIcon(root);
        }
        if (root.querySelectorAll) {
            root.querySelectorAll(selector).forEach(replaceIcon);
        }
    }

    replaceIcons(document);

    if ('MutationObserver' in window) {
        new MutationObserver(function (records) {
            records.forEach(function (record) {
                if (record.type === 'attributes') {
                    var current = record.target;
                    var iconClass = Array.prototype.slice.call(current.classList).find(function (name) {
                        return name.indexOf('fa-') === 0 && name !== 'fa-fw';
                    });
                    var use = current.querySelector('use');
                    if (iconClass && use) {
                        var prefix = current.classList.contains('fab') ? 'fab' : current.classList.contains('far') ? 'far' : 'fas';
                        use.setAttribute('href', sprite + '#' + prefix + '-' + iconClass.slice(3));
                    }
                    return;
                }
                record.addedNodes.forEach(replaceIcons);
            });
        }).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }
})(window, document);
